module.exports = __webpack_public_path__ + "static/media/_bang.89b56510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_bang.jpg
// module id = 49
// module chunks = 0